import React from 'react'
import { FocusScope } from 'react-aria'

import { Popover as PopoverComponent } from '../../store/styled'

export const Popover = ({
 children,
 floatingStyles,
 getFloatingProps,
 refs,
}) => (
    <FocusScope contain autoFocus restoreFocus>
        <PopoverComponent
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
        >
            {children}
        </PopoverComponent>
    </FocusScope>
)
